import { Component } from '@angular/core';
import { environment } from '@environments/environment';

@Component({
    selector: 'app-footer-cmp',
    templateUrl: 'footer.component.html',
    standalone: false
})
export class FooterComponent {
  public version: string = '';
  constructor() {
    this.version = environment.appVersion;
  }
  date: Date = new Date();
}
